import $ from 'jquery';
import map from 'ramda/src/map';
import prop from 'ramda/src/prop';
import * as breakpoints from './breakpoints';
import Vue from 'vue';
import Modal from './modal';
import { EVENT_HIDDEN, EVENT_SHOWN } from './Bootstrap/Modal';

const mediaMobile = breakpoints.down('540px');

/**
 *
 * @param {Element} carousel
 * @param {Element} thumbs
 * @returns
 */
async function initGallery(carousel, thumbs) {
	return import('swiper/bundle').then(({ default: Swiper }) => {
		const nextEl = thumbs.querySelector('.product-gallery-pagination-button-next');
		const prevEl = thumbs.querySelector('.product-gallery-pagination-button-prev');
		const thumbsSwiper = new Swiper(thumbs, {
			init: false,
			navigation: {
				prevEl,
				nextEl,
			},
			slidesPerView: 'auto',
			direction: 'vertical',
			a11y: {
				enabled: false,
			},
		});

		const pagination = carousel.querySelector('.product-gallery__carousel-pagination');
		const carouselSwiper = new Swiper(carousel, {
			init: false,
			slidesPerView: 1,
			pagination: {
				el: pagination,
			},
		});

		const updateThumbs = ({ activeIndex }) => {
			thumbsSwiper.slides.removeClass('swiper-slide-thumb-active');
			thumbsSwiper.slides.eq(activeIndex).addClass('swiper-slide-thumb-active');
			thumbsSwiper.slideTo(activeIndex);
		};

		const slideCarouselTo = ({ clickedIndex }) => {
			if (clickedIndex >= 0)
				carouselSwiper.slideTo(clickedIndex);
		};

		const initThumbs = () => {
			if (!mediaMobile.matches)
				thumbsSwiper.init();
			else
				thumbsSwiper.destroy(false);
		}

		thumbsSwiper.on('init', () => {
			carouselSwiper.on('slideChange', updateThumbs);
			thumbsSwiper.on('click', slideCarouselTo);
		});

		thumbsSwiper.on('beforeDestroy', () => {
			carouselSwiper.off('slideChange', updateThumbs);
			thumbsSwiper.off('click', slideCarouselTo);
		});

		carouselSwiper.on('init', () => {
			if ('addEventListener' in mediaMobile)
				mediaMobile.addEventListener('change', initThumbs);
			else
				mediaMobile.addListener(initThumbs);

			initThumbs();
		});

		carouselSwiper.on('beforeDestroy', () => {
			if ('removeEventListener' in mediaMobile)
				mediaMobile.removeEventListener('change', initThumbs);
			else
				mediaMobile.removeListener(initThumbs);

			thumbsSwiper.destroy(false);
		});

		carouselSwiper.init();

		return carouselSwiper;
	});
}

const webp = string => string.replace(/\.\w+$/, '.webp');
const smMap = map(prop('sm'));
const xlMap = map(prop('xl'));

const ProductGalleryModal = {
	props: {
		initialThumbs: {
			type: Array,
			default: () => [],
		},
		initialItems: {
			type: Array,
			default: () => [],
		},
	},
	data: vm => ({
		items: vm.initialItems,
		thumbs: vm.initialThumbs,
	}),
	mounted() {
		$(this.$refs.modal.$el)
			.on(EVENT_SHOWN, async () => {
				this.$options.swiper = await initGallery(this.$refs.carousel, this.$refs.pagination);
				this.$emit('afterInit');
			})
			.find('.modal-dialog')
				.addClass('modal-xl modal-dialog-scrollable');
	},
	beforeDestroy() {
		if (this.$options.swiper)
			this.$options.swiper.destroy();
	},
	render() {
		return (
			<Modal class="product-gallery-modal" ref="modal">
				<div class="product-gallery">
					<div class="product-gallery__content-left">
						<div ref="pagination" class="product-gallery-pagination-container swiper-container">
							<div class="product-gallery-pagination-wrapper swiper-wrapper">
								{ this.thumbs.map(item => (
									<div class="product-gallery-pagination-item swiper-slide">
										<picture>
											<source src={ webp(item) } type="image/webp"/>
											<img class="product-gallery-pagination-image" loading="lazy" src={ item } />
										</picture>
									</div>
								)) }
							</div>
							<div>
								<button class="product-gallery-pagination-button-prev" tabindex="-1">
									<svg class="-rotate-90" viewBox="0 0 8 14" fill="currentColor" width="8" height="14">
										<path d="M0.726093 13.7369C0.805516 13.8203 0.899832 13.8865 1.00365 13.9316C1.10746 13.9768 1.21874 14 1.33113 14C1.44351 14 1.55479 13.9768 1.65861 13.9316C1.76242 13.8865 1.85674 13.8203 1.93616 13.7369L7.74919 7.64254C7.8287 7.55921 7.89178 7.46026 7.93481 7.35134C7.97785 7.24241 8 7.12566 8 7.00776C8 6.88985 7.97785 6.7731 7.93481 6.66418C7.89178 6.55526 7.8287 6.4563 7.74919 6.37298L1.93616 0.278652C1.85747 0.191905 1.76302 0.122566 1.65838 0.0747198C1.55374 0.026873 1.44103 0.00148907 1.3269 6.23591e-05C1.21276 -0.00136435 1.09951 0.0211967 0.993812 0.0664142C0.888117 0.111633 0.792121 0.178592 0.71148 0.263348C0.630839 0.348103 0.567186 0.448936 0.524274 0.559907C0.481362 0.670878 0.460058 0.78974 0.46162 0.909484C0.463181 1.02923 0.487575 1.14743 0.533364 1.25713C0.579154 1.36683 0.645413 1.4658 0.728233 1.54821L5.93623 7.00776L0.728232 12.4673C0.648581 12.5505 0.585337 12.6493 0.542117 12.7582C0.498898 12.867 0.47655 12.9837 0.476351 13.1016C0.476152 13.2195 0.498108 13.3363 0.540961 13.4453C0.583813 13.5543 0.646723 13.6534 0.726093 13.7369Z"></path>
									</svg>
								</button>
								<button class="product-gallery-pagination-button-next" tabindex="-1">
									<svg class="rotate-90" viewBox="0 0 8 14" fill="currentColor" width="8" height="14">
										<path d="M0.726093 13.7369C0.805516 13.8203 0.899832 13.8865 1.00365 13.9316C1.10746 13.9768 1.21874 14 1.33113 14C1.44351 14 1.55479 13.9768 1.65861 13.9316C1.76242 13.8865 1.85674 13.8203 1.93616 13.7369L7.74919 7.64254C7.8287 7.55921 7.89178 7.46026 7.93481 7.35134C7.97785 7.24241 8 7.12566 8 7.00776C8 6.88985 7.97785 6.7731 7.93481 6.66418C7.89178 6.55526 7.8287 6.4563 7.74919 6.37298L1.93616 0.278652C1.85747 0.191905 1.76302 0.122566 1.65838 0.0747198C1.55374 0.026873 1.44103 0.00148907 1.3269 6.23591e-05C1.21276 -0.00136435 1.09951 0.0211967 0.993812 0.0664142C0.888117 0.111633 0.792121 0.178592 0.71148 0.263348C0.630839 0.348103 0.567186 0.448936 0.524274 0.559907C0.481362 0.670878 0.460058 0.78974 0.46162 0.909484C0.463181 1.02923 0.487575 1.14743 0.533364 1.25713C0.579154 1.36683 0.645413 1.4658 0.728233 1.54821L5.93623 7.00776L0.728232 12.4673C0.648581 12.5505 0.585337 12.6493 0.542117 12.7582C0.498898 12.867 0.47655 12.9837 0.476351 13.1016C0.476152 13.2195 0.498108 13.3363 0.540961 13.4453C0.583813 13.5543 0.646723 13.6534 0.726093 13.7369Z"></path>
									</svg>
								</button>
							</div>
						</div>
					</div>
					<div class="product-gallery__content-right">
						<div ref="carousel" class="product-gallery__carousel swiper-container">
							<div class="product-gallery__carousel-wrapper swiper-wrapper">
								{ this.items.map(item => (
									<div class="product-gallery__carousel-item swiper-slide">
										<picture>
											<source src={ webp(item) } type="image/webp"/>
											<img class="product-gallery__carousel-item-image" loading="lazy" src={ item }/>
										</picture>
									</div>
								)) }
							</div>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
};

const ProductGalleryModalDisposable = Vue.extend({
	extends: ProductGalleryModal,
	mounted() {
		$(this.$refs.modal.$el).on(EVENT_HIDDEN, () => {
			this.$destroy();
			this.$el.parentNode.removeChild(this.$el);
		});
	},
});

document.addEventListener('DOMContentLoaded', async () => {
	const prefix = 'product-gallery';
	const carouselContainer = document.querySelector(`.${prefix}__carousel`);
	const paginationContainer = document.querySelector(`.${prefix}-pagination-container`);

	if (!carouselContainer || !paginationContainer)
		return;

	const zoomButton = carouselContainer.querySelector('[data-product-gallery-modal-toggle="show"]');
	const galleryData = document.getElementById('gallery-data');

	const nonModalGallery = await initGallery(carouselContainer, paginationContainer);

	zoomButton.addEventListener('click', () => {
		const data = JSON.parse(galleryData.text);
		const thumbs = smMap(data);
		const items = xlMap(data);
		const modal = new ProductGalleryModalDisposable({
			data: () => ({
				items,
				thumbs,
			}),
		});

		modal.$on('afterInit', () => modal.$options.swiper.slideTo(nonModalGallery.activeIndex));
		modal.$mount();
		document.body.appendChild(modal.$el);
		$(modal.$refs.modal.$el).modal('show');
	});
});
